import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { menuData as globalMenuData } from './menu.data';
import { AuthService } from 'src/app/auth/auth.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { filter, takeUntil, mergeMap } from 'rxjs/operators';
import { BehaviorSubject, combineLatest, Subject, of, Observable } from 'rxjs';
import { PermissionKey } from '../models/permission.model';
import { RoutePermissionMap } from 'src/app/shared/mappers/permission.mapper';
import { FlowService } from 'src/app/flow.service';
declare var bootstrap: any;

type IGlobalMenu = typeof globalMenuData;

@Component({
  selector: 'rft-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
})
export class SidebarComponent implements OnInit, OnDestroy {
  $destroy = new Subject();
  private openId = environment.openId;
  private adminUrl = environment.hostUrl;
  isLoading = true;

  isFullSidebar: boolean = true;
  permission: any;
  envText: 'Dev' | 'Prod' | '' = '';

  currentPath?: string;
  mainMenuLabel: any;
  menuData: Observable<IGlobalMenu>;
  subMenus: Observable<IGlobalMenu[0]['submenu']>;
  allMenuPermission = new BehaviorSubject<string[]>([]);

  flowService = inject(FlowService);

  constructor(
    private http: HttpClient,
    public router: Router,
    private _authService: AuthService
  ) {
    // Left most sidebar routes filtering
    this.menuData = this.allMenuPermission.pipe(
      mergeMap((p) => {
        console.log('Permissions in sidebar', p);
        const data = globalMenuData.filter((r) =>
          this.permissionChecker(p, r.mainMenuPermission)
        );
        return of(data);
      })
    );

    // Submenu routes fileting
    this.subMenus = combineLatest([
      this.router.events.pipe(
        filter((e): e is NavigationEnd => e instanceof NavigationEnd)
      ),
      this.allMenuPermission,
      this.menuData,
    ]).pipe(
      takeUntil(this.$destroy),
      // Skipping from here if navigating inside child routes
      filter(([r]) => !r.url.match(`/${this.currentPath}/?`)),
      // If not inside child routes
      mergeMap(([r, p, m]) => {
        // Finding active route
        const activeMenu = m.find((x) =>
          r.urlAfterRedirects.match(`/${x.path}/?`)
        );

        // Setting sub menu label
        this.mainMenuLabel = activeMenu?.mainMenuLabel;

        // Filtering submenus based on subMenuPermission
        const filteredSubMenus =
          activeMenu?.submenu?.filter((r) =>
            this.submenuPermissionChecker(p, r.subMenuPermission)
          ) ?? [];

        // current path flag
        this.currentPath = activeMenu?.path;
        console.log(filteredSubMenus);
        return of(filteredSubMenus);
      })
    );
  }

  ngOnInit(): void {
    this.burgerMenu();
    this.callPermissionApi();
    this.fetchPrizeZones();
    var tooltipTriggerList = [].slice.call(
      document.querySelectorAll('[data-bs-toggle="tooltip"]')
    );
    var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
      return new bootstrap.Tooltip(tooltipTriggerEl);
    });
    // this.selectMenu('inactive');
    this.envText = this.env; // will determine the env
  }

  burgerMenu() {
    this.isFullSidebar = !this.isFullSidebar;
    let that = this;
    // this.toggleBurger();
    //newly added now
    if (this.isFullSidebar) {
      const elem = document.getElementById('sidebar-max');
      // const mainMenuLabelId = document.getElementById("mainMenuLabel");
      elem?.addEventListener('click', function (event: any) {
        console.log('clicked on sidebar max');

        if (elem?.classList.contains('main-menu-max-width')) {
          if (
            ['burger-menu-closed', 'submenu-section', 'content-body'].includes(
              event.target.id
            )
          ) {
            elem?.classList.remove('main-menu-max-width');
            elem?.classList.add('main-menubar');
            elem?.removeEventListener('click', function () {
              return false;
            });
          }
        }
      });

      const content = document.getElementById('content-body');
      content?.addEventListener('click', function (event: any) {
        console.log('clicked on content-body');
        const elem = document.getElementById('sidebar-max');
        if (elem?.classList.contains('main-menu-max-width')) {
          elem?.classList.remove('main-menu-max-width');
          elem?.classList.add('main-menubar');
          that.isFullSidebar = !that.isFullSidebar;
        }
      });
    }
  }

  public callPermissionApi() {
    const token = localStorage.getItem('accessToken');
    let permissionApi = `${this.openId.accountsUrl}/v1/permission/mine`;
    var header = {
      headers: new HttpHeaders().set('Authorization', `Bearer ${token}`),
    };
    this.http.get(permissionApi, header).subscribe({
      next: (response: any) => {
        const { code, ...rest } = response['data'].items[0];
        localStorage.setItem('permission', JSON.stringify(rest));
        localStorage.setItem('role', code);
        this.flowService.setPermission();
        this.flowService.setRole();
        this.hasPermission();
      },
      error: (err) => console.log(err),
      complete: () => (this.isLoading = false),
    });
  }

  hasPermission() {
    // this.showSubMenuWhenReloaded();
    this.permission = this.flowService.permission();
    let menuPermission: string[] = [];

    if (this.permission == null) {
      let y = JSON.parse(JSON.stringify(localStorage.getItem('permission')));
      this.permission = JSON.parse(y);
    } else {
      this.permission.read.map((x: PermissionKey) => {
        menuPermission.push(x.accessKey);
      });
      this.allMenuPermission.next([...new Set(menuPermission)]);
    }
  }

  public permissionChecker(ps: string[] = [], p: string) {
    const hasRelatedPermission =
      RoutePermissionMap[p as keyof typeof RoutePermissionMap];
    if (!hasRelatedPermission?.length) return false;
    return hasRelatedPermission.some((perm) => ps.includes(perm));
  }

  public submenuPermissionChecker(
    receivedPermissions: string[] = [],
    p: string
  ) {
    return receivedPermissions.includes(p);
  }

  public logOut() {
    return this._authService.loggedOut();
  }

  public switchToProd() {
    if (!this.envText) return;

    this.envText = this.envText === 'Prod' ? 'Dev' : 'Prod';
    window.location.href =
      this.envText === 'Prod'
        ? `https://devadmin.realfantasyteams.com`
        : 'https://admin.realfantasyteams.com';
  }

  public get env() {
    const PROD_URL = 'https://devadminapi.realfantasyteams.com/adminService';
    const DEV_URL = 'https://adminapi.realfantasyteams.com/adminService';
    return environment.hostUrl === PROD_URL
      ? 'Prod'
      : environment.hostUrl === DEV_URL
      ? 'Dev'
      : '';
  }

  public fetchPrizeZones() {
    const token = localStorage.getItem('accessToken');
    let prizeZonesApi = `${this.adminUrl}/v1/admin/prizeZone/list`;
    var header = {
      headers: new HttpHeaders().set('Authorization', `Bearer ${token}`),
    };
    this.http.get(prizeZonesApi, header).subscribe(
      (response: any) => {
        localStorage.setItem(
          'prizeZones',
          JSON.stringify(response['data']?.items)
        );
      },
      (err) => console.log(err),
      () => (this.isLoading = false)
    );
  }

  ngOnDestroy(): void {
    this.$destroy.next(false);
    this.$destroy.unsubscribe();
  }
}
